import React, { useState } from 'react';
import cx from 'classnames';
import { Transition } from '@headlessui/react';

import { colorGrayLight2 } from 'styles/layout/colors';
import ElleDecor from './logos/ElleDecor';
import WireCutter from './logos/WireCutter';
import TheNewYorkTimes from './logos/TheNewYorkTimes';
import Glamour from './logos/Glamour';
import Refinery29 from './logos/Refinery29';

const pressData = [
  {
    logo: WireCutter,
    quote:
      'Of all the couches we tested, Joybird’s offers the best mix of quality construction, comfort, and price.',
  },
  {
    logo: TheNewYorkTimes,
    quote:
      'A new breed of online furniture manufacturer offering high-end quality, customization & quick turnaround.',
  },
  {
    logo: Glamour,
    quote: 'Joybird is changing the custom furniture game.',
  },
  {
    logo: ElleDecor,
    quote:
      'Well-made, customizable seating inspired by Mid-century styles rule the roost at Joybird furniture.',
  },
  {
    logo: Refinery29,
    quote: `Not only does Joybird offer a range of customizeable mid-century piece, it's an amazing place for design inspo.`,
  },
];

const PDPPressUI = () => {
  const [selectedPressItemIndex, setSelectedPressItemIndex] = useState(0);
  return (
    <div className="border-t border-solid border-gray-light6 mt-12 mb-24 pt-14 [content-visibility: auto] lg:mt-14 lg:mb-0">
      <h2 className="text-xl font-bold mt-1.5 mb-2.5">Joybird in the Press</h2>

      <div className="text-sm mb-6 relative h-16 lg:text-base">
        {pressData.map(({ quote }, idx) => (
          <Transition
            className="absolute"
            key={quote}
            show={selectedPressItemIndex === idx}
            enter="transition-opacity duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <span>&quot;{quote}&quot;</span>
          </Transition>
        ))}
      </div>

      <ul className="flex flex-nowrap list-none m-0 overflow-scroll p-0 [scrollbar-width: none] [&::-webkit-scrollbar]:hidden">
        {pressData.map(({ logo: Logo, quote }, idx) => (
          <li className="mr-4 last:mr-0" key={quote}>
            <button
              type="button"
              className={cx(
                'cursor-pointer list-none p-0 transition-all duration-500 ease-linear bg-none border-none',
                {
                  '[&_path:not([fill=none])]:hover:fill-gray [&_rect:not([fill=none])]:hover:fill-gray':
                    selectedPressItemIndex !== idx,
                }
              )}
              onClick={() => setSelectedPressItemIndex(idx)}
            >
              <Logo
                color={selectedPressItemIndex !== idx ? colorGrayLight2 : null}
              />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PDPPressUI;
